<ng-dialog-header title="Select Company/Locations"></ng-dialog-header>
<mat-dialog-content>
  <ng-container *ngTemplateOutlet="loading ? mask : role === 'SL' ? listScacs : listLocations"></ng-container>
  <ng-container *ngIf="customers.length === 0">
    <h4 class="text-center">No Locations Available!</h4>
  </ng-container>
</mat-dialog-content>
<ng-dialog-footer>
  <div class="d-flex justify-content-end overflow-hidden w-100" dialog-actions>
    <button mat-stroked-button color="warn" class="mr-2" [mat-dialog-close]="false">Close</button>
    <button mat-flat-button color="accent" (click)="emitLocations()" [mat-dialog-close]="allComplete"
            [disabled]="!(selectedCustomer && selectedCustomer.locations.length > 0)">
      Select
    </button>
  </div>
</ng-dialog-footer>

<ng-template #mask>
  <ns-skeleton [type]="skeleton"></ns-skeleton>
</ng-template>

<ng-template #listScacs>
  <ng-container *ngIf="customers.length > 0">
    <mat-checkbox
      [indeterminate]="isIndeterminate()"
      [checked]="allComplete"
      (change)="selectAllScacs($event.checked)">
      Select All
    </mat-checkbox>
    <div *ngFor="let customer of customers">
      <mat-checkbox
        [checked]="scacChecked(customer?.scac)"
        (change)="selectScac(customer?.scac)">{{ customer?.scac }}
      </mat-checkbox>
    </div>
  </ng-container>
</ng-template>

<ng-template #listLocations>
  <ng-container *ngIf="customers.length > 0">
    <mat-radio-group>
      <ng-container *ngFor="let customer of customers">
        <mat-radio-button [value]="customer"
                          [name]="customer.customerName"
                          [checked]="customer.customerName === selectedCustomer?.customerName"
                          class="mt-3"
                          (change)="select($event)">
          {{ customer.customerName }}
        </mat-radio-button>
        <section class="mt-3">
          <div class="row">
            <div *ngIf="customer.locations.length > 1" class="col col-lg-4">
              <mat-checkbox
                [checked]="customer.customerName === selectedCustomer?.customerName ? allComplete : false"
                [indeterminate]="customer.customerName === selectedCustomer?.customerName ? isIndeterminate() : false"
                [disabled]="!(customer.customerName === selectedCustomer?.customerName)"
                (change)="selectAll($event.checked, customer.locations)">
                Select All
              </mat-checkbox>
            </div>
            <ng-container *ngFor="let loc of customer.locations">
              <div class="col col-lg-4">
                <mat-checkbox
                  (change)="updateSelectedLocations(loc, customer.locations.length)"
                  [checked]="customer.customerName === selectedCustomer?.customerName && locationExist(loc)"
                  [disabled]="!(customer.customerName === selectedCustomer?.customerName)">
                  {{ parseLocations(loc, customer?.scac) }}
                </mat-checkbox>
              </div>
            </ng-container>
          </div>
        </section>
        <mat-divider class="mt-2 mb-2"></mat-divider>
      </ng-container>
    </mat-radio-group>
  </ng-container>
</ng-template>
